import IndustrialView from "./IndustrialView";

export default IndustrialView;
